import { bulk } from './update';
import addError from '../../../utils/error.jsx';

export function request(id, data) {
    return {
        type: 'COMPETITIONS_SAVE_REQUEST',
        data,
        id
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'COMPETITIONS_SAVE_ERROR',
        errors
    };
}

export function finish(competition) {
    return (dispatch) => {
        dispatch(bulk([ competition ]));

        dispatch({
            type: 'COMPETITIONS_SAVE_FINISH',
            competition
        });
    };
}

export function clear() {
    return {
        type: 'COMPETITIONS_SAVE_CLEAR'
    };
}
